import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { PRIORITY_COLORS, PRIORITY_LABELS, TASK_PRIORITY_ORDER } from 'modules/shared/constants';

/**
 * @param {Object} props
 * @param {string} props.value - Selected priority (enum)
 * @param {(value: string) => void} props.onChange
 * @param {boolean} [props.disabled=false]
 * @returns {JSX.Element}
 */
export default function PrioritySelector({ value, onChange, disabled = false }) {
  return (
    <Box sx={{ display: 'flex', gap: 0 }}>
      {TASK_PRIORITY_ORDER.map((priority) => {
        const selected = value === priority;

        return (
          <Button
            key={priority}
            type='button'
            onClick={() => onChange(priority)}
            disabled={disabled}
            disableElevation
            variant={selected ? 'contained' : 'outlined'}
            sx={priorityStyles(priority, selected)}
          >
            {PRIORITY_LABELS[priority]}
          </Button>
        );
      })}
    </Box>
  );
}

function priorityStyles(priority, selected) {
  return {
    textTransform: 'none',
    minWidth: 90,
    fontWeight: 600,
    border: '2px solid',
    padding: '4px 12px',
    borderColor: PRIORITY_COLORS[priority],
    color: selected ? '#fff' : PRIORITY_COLORS[priority],
    backgroundColor: selected ? PRIORITY_COLORS[priority] : 'transparent',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: selected ? PRIORITY_COLORS[priority] : `${PRIORITY_COLORS[priority]}22`,
    },
    '&:first-of-type': {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
    },
    '&:last-of-type': {
      borderTopRightRadius: 6,
      borderBottomRightRadius: 6,
    },
    '&:disabled': {
      opacity: 0.6,
      cursor: 'default',
      border: '2px solid',
      borderColor: `${PRIORITY_COLORS[priority]}80`,
      color: `${PRIORITY_COLORS[priority]}`,
      backgroundColor: 'transparent',
    },
  };
}
